<div class="review-list">
    <div class="review-list__item" *ngFor="let review of reviews">

        <!-- Comment -->
        <div class="review-list__comment">
            <div class="review-list__img">
                <wuc-picture
                    imageDesktop="https://www.insocial.nl{{ review.avatar }}"
                    imageType="image/jpg"
                    [imageWidth]="{ desktop: 116 }"
                    [imageHeight]="{ desktop: 157 }"
                    [lazyLoad]="false"
                    [alt]="review.naam"
            ></wuc-picture>
            </div>
            <div class="review-list__balloon">
                <div class="review-balloon review-balloon--left">
                    <div class="review-balloon__balloon">
                        <div class="review-balloon__score">{{ review.score }}</div>
                        <div class="review-balloon__content review-balloon__content--alignleft">
                            <div class="review-balloon__wrap">
                                <h3 class="review-balloon__name">{{ review.naam }}</h3>
                                <span class="review-balloon__date">{{ review.beoordelingstijd_omschrijving }}</span>
                                <p *ngIf="review.testimonial">{{ review.testimonial }}</p>
                                <p *ngIf="!review.testimonial">Geen commentaar</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Rating -->
        <div class="review-list__rating">
            <div class="review-list__rating-item" *ngFor="let vraag of review.vragen">
                <span alt="vraag.vraag">
                    <ng-container *ngIf="vraag.onderwerp !== 'CES'">
                        {{ vraag.onderwerp }}
                    </ng-container>
                    <ng-container *ngIf="vraag.onderwerp === 'CES'">
                        Gemak
                    </ng-container>
                </span>
                <div class="review-list__rating-bar">
                    <div [ngStyle]="{'width': vraag.score + '0%'}"></div>
                </div>
            </div>
        </div>

        <!-- Answer -->
        <div class="review-list__comment review-list__comment--answer"
            *ngIf="review.antwoord">
            <div class="review-list__img review-list__img--fleur">
                <wuc-picture 
                    imageDesktop="/assets/shared/01_algemeen/05_fleur/old/fleur-67x155.png" 
                    imageType="image/png"
                    [imageWidth]="{ desktop: 67 }"
                    [imageHeight]="{ desktop: 155 }"
                    [lazyLoad]="false"
                    alt="Fleur">
                </wuc-picture>
            </div>
            <div class="review-list__balloon review-list__balloon--fleur">
                <div class="review-balloon review-balloon--right">
                    <div class="review-balloon__balloon">
                        <div class="review-balloon__content review-balloon__content--alignleft">
                            <div class="review-balloon__wrap">
                                <p>{{ review.antwoord }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

    <!-- Paging -->
    <ins-paging [totalPages]="totalPages" (pageSelected)="pageSelectedHandler($event)"></ins-paging>
</div>
